import React from 'react';
import config from '@finsight/config';
import { FinsightTenant } from '@/finsight/domain/vo/types/FinsightTenant';
import BookDemoButton from '@/Framework/UI/Organisms/ScheduleDemo/ScheduleDemoModal/BookDemoButton';

const FinsightBookDemo = () => (
  <BookDemoButton
    tenant={ config.code as FinsightTenant }
    title="Book Demo"
  />
);

export default FinsightBookDemo;
